module.exports = __webpack_public_path__ + "static/media/8.3da57418.jpg";